export const languageKeys = [
  'ar',
  'de',
  'en',
  'es',
  'fr',
  'pt',
  'ru',
  'tr',
  'uk',
] as const;
export const defaultLanguageKey = languageKeys[1]; // 'de'
export type LanguageKey = (typeof languageKeys)[number];
export const languageLabels: Partial<Record<LanguageKey, string>> = {
  ar: 'Arabisch - العربية',
  de: 'Deutsch - Deutsch',
  en: 'Englisch - English',
  es: 'Spanisch - Español',
  fr: 'Französisch - Français',
  pt: 'Portugiesisch - Português',
  ru: 'Russisch - Русский',
  tr: 'Türkisch - Türkçe',
  uk: 'Ukrainisch - Українська',
} as const;
export const publishedLanguageLabels: Partial<Record<LanguageKey, string>> = {
    // ar: 'Arabisch - العربية',
    de: 'Deutsch - Deutsch',
    // en: 'Englisch - English',
    // es: 'Spanisch - Español',
    // fr: 'Französisch - Français',
    // pt: 'Portugiesisch - Português',
    ru: 'Russisch - Русский',
    // tr: 'Türkisch - Türkçe',
    uk: 'Ukrainisch - Українська',
  };

/**
 * {de: string, uk: string | null, ...}
 */
export type TranslatableText<RequiredLang extends LanguageKey = 'de'> = {
  [K in RequiredLang]: string;
} & { [K in Exclude<LanguageKey, RequiredLang>]?: string | null };

export function isLanguageKey(value: string): value is LanguageKey {
  return languageKeys.includes(value as LanguageKey);
}
export function checkBrowserLanguage(browserLanguage?: string): LanguageKey {
  if (!browserLanguage) return defaultLanguageKey;

  return isLanguageKey(browserLanguage) ? browserLanguage : defaultLanguageKey;
}
export function translateVar(value: TranslatableText<"de"> | undefined, currentLang: string, withDefault: boolean = false): string | undefined | null{
    if(!value) return undefined;
    const lang = checkBrowserLanguage(currentLang);
    if(lang in value && value[lang]) return value[lang];    
    if(withDefault && defaultLanguageKey in value && value[defaultLanguageKey]) return value[defaultLanguageKey];
    return undefined;
}